import { createAction } from 'redux-actions';
import * as commons from 'services/commons';

export const SIKDAEGROUP_LIST = 'SIKDAEGROUP_LIST';
export const SIKDAEPOLICY_LIST = 'SIKDAEPOLICY_LIST';
export const SIKDAEPOLICY_ARRAY = 'SIKDAEPOLICY_ARRAY';
export const STORE_LIST = 'STORE_LIST';
export const DIVISION_LIST = 'DIVISION_LIST';
export const STAFF_DIVISION_LIST = 'STAFF_DIVISION_LIST';
export const PAST_DIVISION_LIST = 'PAST_DIVISION_LIST';
export const CHANGE_DIVISION = 'CHANGE_DIVISION';
export const REDUX_DATA_SET = 'REDUX_DATA_SET';
export const SIKDAEPOLICY_MOD = 'SIKDAEPOLICY_MOD';
export const STAFF_SEL = 'STAFF_SEL';
export const STAFF_DEATIL_SEL = 'STAFF_DEATIL_SEL';
export const CHANGE_EXCEL_DATA = 'CHANGE_EXCEL_DATA';
export const EXCEL_DOWNLOAD = 'EXCEL_DOWNLOAD';
export const STAFF_BARCODE_INFO = 'STAFF_BARCODE_INFO';
export const PRESET_SET = 'PRESET_SET';
export const DORMANT_STAFF = 'DORMANT_STAFF';
export const STORE_EXCEL_DOWNLOAD = 'STORE_EXCEL_DOWNLOAD';
export const DIVISION_ALL = 'DIVISION_ALL';

// 식대그룹 조회
export const SikdaeGroupList = (params) => ({
  type: SIKDAEGROUP_LIST,
  payload: {
    promise: commons.SikdaeGroupList(params)
  }
});

// 식대정책 조회
export const SikdaePolicyList = (idx) => ({
  type: SIKDAEPOLICY_LIST,
  payload: {
    promise: commons.SikdaePolicyList(idx)
  }
});

// 식대정책 Array
export const SikdaePolicyArray = (idx) => ({
  type: SIKDAEPOLICY_ARRAY,
  payload: {
    promise: commons.SikdaePolicyList(idx)
  }
});

// 식대정책 수정
export const SikdaePolicyMod = (idx, params) => ({
  type: SIKDAEPOLICY_MOD,
  payload: {
    promise: commons.SikdaePolicyMod(idx, params)
  }
});

// 가맹점 조회
export const StoreList = (params) => ({
  type: STORE_LIST,
  payload: {
    promise: commons.StoreList(params)
  }
});

// 부서 조회
export const DivisionList = () => ({
  type: DIVISION_LIST,
  payload: {
    promise: commons.DivisionList()
  }
});

// 인사 및 부서 조회
export const StaffDivisionList = (params) => ({
  type: STAFF_DIVISION_LIST,
  payload: {
    promise: commons.StaffDivisionList(params)
  }
});

// 과거 부서 조회
export const PastDivisionList = (params) => ({
  type: PAST_DIVISION_LIST,
  payload: {
    promise: commons.PastDivisionList(params)
  }
});

// 사용자 조회
export const StaffSel = (params) => ({
  type: STAFF_SEL,
  payload: {
    promise: commons.StaffSel(params)
  }
});

// 사용자 상세 조회
export const StaffDetailSel = (params) => ({
  type: STAFF_DEATIL_SEL,
  payload: {
    promise: commons.StaffDetailSel(params)
  }
});

// 휴면 사용자 조회
export const dormantStaff = (params) => ({
  type: DORMANT_STAFF,
  payload: {
    promise: commons.dormantStaff(params)
  }
});

// 사용자 바코드 정보 조회
export const StaffBarcode = (params) => ({
  type: STAFF_BARCODE_INFO,
  payload: {
    promise: commons.StaffBarcode(params)
  }
});

// 부서 선택
export const ChangeDivision = createAction(CHANGE_DIVISION);

// Select box, input box change Action
export const ReduxDataSet = createAction(REDUX_DATA_SET);

export const ChangeExcel = createAction(CHANGE_EXCEL_DATA);

// 엑셀 다운로드
export const ExcelDownload = (params) => ({
  type: EXCEL_DOWNLOAD,
  payload: {
    promise: commons.ExcelDownload(params)
  }
});

// 권한 설정 목록
export const PresetSel = (params) => ({
  type: PRESET_SET,
  payload: {
    promise: commons.PresetSel(params)
  }
});

export const StoreExcelDownload = (params) => ({
  type: STORE_EXCEL_DOWNLOAD,
  payload: {
    promise: commons.StoreExcelDownload(params)
  }
});

export const getDivisionALL = (params) => ({
  type: DIVISION_ALL,
  payload: {
    promise: commons.DivisionALL(params)
  }
});
